import {getWindow, isSandbox, isIOS, isAndroid, isKakaoTalk} from '@src/utils/common';
import {PROTOCOL_PREFIX, TALK_SCHEME} from '@src/constants';

export const goLocation = (href: string) => {
  const window = getWindow();
  if ('location' in window && href) {
    window.location.href = href;
  }
};

/*
 * 스킴 프로토콜의 prefix를 반환합니다.
 * - Android: kakao
 * - IOS:
 *   - 알파, 샌드박스: alpha
 *   - 베타, CBT, 운영: kakao
 */
const getProtocolPrefix = (): string => (isIOS() && isSandbox() ? PROTOCOL_PREFIX.ALPHA : PROTOCOL_PREFIX.KAKAO);

/**
 * app scheme의 프로토콜을 환경에 맞춰 변경합니다.
 * @param {string} scheme app scheme
 * @returns {string} app scheme
 */
const replaceProtocol = (scheme: string): string => {
  const protocolPrefix = getProtocolPrefix();
  return scheme.replace(/^(kakao)/, protocolPrefix);
};

const toIntent = (scheme: string): string => {
  const kakaotalkPackage = isSandbox() ? 'com.kakao.talk.sandbox' : 'com.kakao.talk';
  const [protocol, href] = scheme.split('://');
  return `intent://${href}#Intent;package=${kakaotalkPackage};scheme=${protocol};end;`;
};

export const executeScheme = (scheme: string): void => {
  const appScheme = replaceProtocol(scheme);

  if (isAndroid()) {
    goLocation(isKakaoTalk() ? appScheme : toIntent(appScheme));
  } else {
    goLocation(appScheme);
  }
};

// 구독 전용 웹뷰 실행
export const callOpenSubscriptionWebview = (url: string): void => {
  executeScheme(`${TALK_SCHEME.SUBSCRIPTION_OPEN}?url=${encodeURIComponent(url)}`);
};

// 채널 홈 이동
export const callOpenChannelHome = (): void => {
  const CHANNEL_UUID = process.env.NEXT_PUBLIC_BIZ_MESSAGE_UUID || '';
  executeScheme(`${TALK_SCHEME.CHANNEL_HOME}/${encodeURIComponent(CHANNEL_UUID)}`);
};

export const callOpenChannelHomeWithUrl = (url: string): void => {
  const CHANNEL_UUID = process.env.NEXT_PUBLIC_BIZ_MESSAGE_UUID || '';
  executeScheme(`${TALK_SCHEME.CHANNEL_HOME}/${encodeURIComponent(CHANNEL_UUID)}?url=${encodeURIComponent(url)}`);
};

// 채널 홈 내 특정 페이지 접근 스킴 반환
export const getChannelHomeScheme = (url: string): string => {
  const CHANNEL_UUID = process.env.NEXT_PUBLIC_BIZ_MESSAGE_UUID || '';
  const scheme = replaceProtocol(TALK_SCHEME.CHANNEL_HOME);
  return `${scheme}/${CHANNEL_UUID}?url=${encodeURIComponent(url)}`;
};

export const closeWebview = () => {
  executeScheme(TALK_SCHEME.WEVIEW_CLOSE);
};

export const closeInAppBrowser = () => {
  executeScheme(TALK_SCHEME.INAPPBROWSER_CLOSE);
};
